/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsSearch = {
  init: function($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsSearch = $.extend(this, window.PXUTheme.getSectionData($section));

    // If breadcrumbs enabled and basic pagination is set, call breadcrumbs object
    if (this.enable_breadcrumb && this.pagination_type == 'basic_pagination') {
      window.PXUTheme.breadcrumbs.init(this.number_of_pages);
    }

    // Submit the search filter/sort form when the sort dropdown changes
    $('[data-search-sort]').on('change', function() {
      var $form = $(this).closest('[data-search-filter-form]');
      if ($form.length) {
        $form.get(0).submit();
      }
    });
  },
  unload: function($target) {
    $('[data-search-sort]').off();
    window.PXUTheme.breadcrumbs.unload();
  }
}


/******/ })()
;